import parse from "html-react-parser";
import React from "react";
import { Dialog, Modal, XIcon } from "staysure-component-library";
import "../../../../app/globals.css"; // medical screening ui issue fix

import LabelButtonWrapper, {
  IconButtonWrapper,
} from "@/components/atoms/button-wrapper/button-wrapper";
import selectedColorBrand from "@/config/tailwind-colors/brand-colors";

type APIErrorModalProps = {
  title: string;
  ctaPrimaryBtnLabel?: string;
  isOpenModal?: boolean;
  onOpenChange?: (value: boolean) => void;
  onPrimaryCtaClick?: (value: boolean) => void;
  isCloseIconEnabled?: boolean;
  description: string;
};

function APIErrorModalRenewal(props: Readonly<APIErrorModalProps>) {
  const {
    title,
    ctaPrimaryBtnLabel,
    isOpenModal,
    isCloseIconEnabled = true,
    description,
    onOpenChange,
    onPrimaryCtaClick,
  } = props;

  return (
    <Modal
      modalStyles={{
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
      }}
      className="!w-[327px] p-spacing-l md:!w-[416px] md:p-spacing-xxxl bg-surface-neutral-option-1 relative rounded-radius-lg"
      uderlayClassName="z-[201] bg-interactive-overlay-default"
      isOpen={isOpenModal}
      isDismissable={false}
      onOpenChange={(value: boolean) => {
        if (onOpenChange) onOpenChange(value);
      }}
    >
      <div className="items-center justify-center px-spacing-xxs py-spacing-xxs gap-spacing-xs w-auto h-auto absolute top-0 right-0">
        {/* Close icon  */}
        {isCloseIconEnabled && (
          <IconButtonWrapper
            data-testid="error-modal-close-icon-button"
            id="error-modal-close-icon-button"
            hierarchy="tertiary"
            btnType="icon"
            icon={
              <XIcon
                stroke={selectedColorBrand["interactive-secondary-default"]}
                testId="closeAPIErrorModalIcon-testid"
              />
            }
            className="w-[48px] h-[48px] rounded-radius-lg py-spacing-s px-spacing-m gap-spacing-xs text-[24px] text-text-on-primary"
            onClick={() => {
              if (onOpenChange) onOpenChange(false);
            }}
          />
        )}
      </div>

      <Dialog className="relative">
        <div className="">
          <h1 className="text-center font-header-font !text-m md:!text-3xl text-text-title md:leading-custom-size-xl leading-[28px] line-clamp-2">
            {title && parse(title)}
          </h1>

          {description && (
            <p className="text-center self-stretch text-text-body  font-body-font text-[18px] font-normal leading-[27px] mt-spacing-xs md:mt-spacing-s">
              {description && parse(description)}
            </p>
          )}

          <LabelButtonWrapper
            data-testid="error-modal-primary-button"
            id="error-modal-primary-button"
            hierarchy="primary"
            className="text-text-on-primary px-spacing-l py-spacing-s w-[279px] md:w-[304px] mx-auto !h-[48px] !leading-custom-size-xs mt-spacing-l "
            label={ctaPrimaryBtnLabel ?? "Back"}
            onClick={() => {
              if (onPrimaryCtaClick) onPrimaryCtaClick(false);
            }}
          />
        </div>
      </Dialog>
    </Modal>
  );
}

export default APIErrorModalRenewal;
